import React from 'react';

function Slogan() {
  return (
    <h1 className='hero__slogan'>
      Чистый Воздух
      <span className='hero__text-with-long-line'>Вместе С</span>
      <span className='hero__company-name'>PASCAL VENT</span>
    </h1>
  );
}

export default Slogan;
